module.exports = __webpack_public_path__ + "img/1543612283.48c7a823.jpg";